import { Track } from "../../../interfaces/dtos/track";
import { TrackForm } from "./TrackForm";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { commonState } from "../../../redux/common/commonSlice";
import { Box } from "@mui/material";
import { Loading } from "../../shared/Loading";
import { LoadingError } from "../../shared/LoadingError";
import { createKey, saveTrack } from "../../../redux/track/trackAction";
import { trackState } from "../../../redux/track/trackSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { trackRoutesCombined } from "../TrackNavigation";
import { useFeedback } from "@sis/react-library";
import { dispatchIsSuccessful } from "../../../utils/commonUtils";

export interface TrackFormWrapperProps {
    track: Track;
}

export const TrackFormWrapper = ({
    track
}: TrackFormWrapperProps) => {

    const common = useAppSelector(commonState);
    const state = useAppSelector(trackState);
    const dispatch = useAppDispatch();
    const { showSuccess } = useFeedback();

    const navigate = useNavigate();
    const location = useLocation();

    const forNew = track.sportCode === undefined;

    const handleSubmit = async (values: Track) => {
        const result = await dispatch(saveTrack(values));
        const success = dispatchIsSuccessful(result);
        if (success) {
            showSuccess(`Track was ${forNew ? 'created' : 'saved'}.`);
            if (forNew) { navigateToEdit(values); }
        }
        return success;
    }

    const navigateToEdit = (values: Track) => {
        globalThis.setTimeout(() => {
            const key = createKey(values);
            navigate(`${trackRoutesCombined.edit}${key}${location.search}`);
        }, 500);
    }

    return (
        <>
            {(common.loadingCountries || common.loadingProviders) &&
                <Box sx={{ textAlign: 'center' }}><Loading /></Box>
            }
            {!common.loadingCountries && (common.countries.length === 0) &&
                <LoadingError>Could not load countries</LoadingError>
            }
            {!common.loadingProviders && (common.providers.length === 0) &&
                <LoadingError>Could not load providers</LoadingError>
            }
            {!common.loadingCountries && !common.loadingProviders &&
                common.countries.length > 0 && common.providers.length > 0 &&
                <TrackForm
                    track={track}
                    onSubmit={handleSubmit}
                    providers={common.providers}
                    submitting={state.saving}
                />
            }
        </>
    )
}
